<template>
  <section v-if="photos">
    <div class="row">
      <div class="col-12">
        <carousel :perPage="$mq.phone ? 2 : 3"
                  :autoplay="false"
                  :centerMode="false"
                  :autoplayHoverPause="true"
                  :navigationEnabled="true"
                  :paginationEnabled="false"
                  :loop="true"
                  :autoplayTimeout="3000"
                  :scrollPerPage="false"
                  :mouseDrag="true"
                  :touchDrag="true">
          <template v-for="(photo, index) in photos">
            <slide @slideclick="setGalleryIndex(index)">
              <div class="m-2 pointer-item">
                <div class="image-container" v-lazy:background-image="photo.image_xl"></div>
              </div>
            </slide>
          </template>
        </carousel>
      </div>
    </div>
    <!-- Gallery -->
    <Tinybox v-model="galleryIndex" :images="_.map(photos,'image_xl')" loop no-thumbs v-if="includeGallery" style="z-index: 9999;" />
  </section>
</template>

<script>
  import { Carousel, Slide } from 'vue-carousel'

  export default {
    props: {
      photos: Array,
      photoType: String,
      includeGallery: Boolean
    },
    components: {
      Carousel,
      Slide
    },
    data () {
      return {
        galleryIndex: null
      }
    },
    methods: {
      setGalleryIndex (index) {
        this.galleryIndex = index
        this.$emit('onItemClick', index, this.photoType)
      }
    },
    mounted () {}
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/PhotosAlbum.vue